import { useEffect } from 'react';
import { PageTitle, Breadcrumbs, PageNotFound, LoadingCircle } from '@gplibraries/react/components';
import { useConfig, useTokenProvider } from '@gplibraries/react/hooks';
import { StringFormatter } from '@gplibraries/utils';
import { useNavigate } from 'react-router';
import Article from '../../components/Article/Article.tsx';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchArticle } from '../../api/articles.js';

export default function ArticlePage(props) {

  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});
  const { nid, title } = useParams();
  const navigate = useNavigate();

  const { isPending, error, data: article } = useQuery({
    enabled: Boolean(getToken),
    queryKey: ['article', nid],
    queryFn: () => getToken()
      .then(token => fetchArticle(dealerAccessApiHost, token.accessToken, nid))
      .then(res => res.status === 404 ? null : res.json())
  })

  // Add the title segment to the URL if only the NID was provided, and if a
  // title was provided make sure it is correct.
  useEffect(() => {
    if (!article) return;
    if (!title || title !== StringFormatter.urlSafe(article.data.title)) {
      navigate(`/article/${nid}/${StringFormatter.urlSafe(article.data.title)}`, { replace: true })
    }
  }, [title, article]);

  if (error) throw error;
  if (isPending) return <LoadingCircle className={'large color'}/>
  if (!isPending && !article) return <PageNotFound/>

  return (
    <div className={'flex-col full'}>
      <Breadcrumbs breadcrumbs={{ [article.data.title]: '' }}/>
      <PageTitle>{article.data.title}</PageTitle>
      <Article article={article.data}/>
    </div>
  );
}